import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class LeadStatusUserInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isLeadStatusChangeRequest(req)) {
      return next.handle(req);
    }

    const userId = this.getUserId();
    if (!userId) {
      return next.handle(req);
    }

    const updatedBody = this.addUserToPayload(req.body, userId);
    if (updatedBody === req.body) {
      return next.handle(req);
    }

    return next.handle(req.clone({ body: updatedBody }));
  }

  private isLeadStatusChangeRequest(req: HttpRequest<any>): boolean {
    if (!req.url || !req.url.includes('lead-status-change')) {
      return false;
    }
    return req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH';
  }

  private getUserId(): string | null {
    const cookieVal = this.cookieService.get('login_user_details');
    if (!cookieVal) {
      return null;
    }
    try {
      const parsed = JSON.parse(cookieVal);
      const id = parsed?.userinfo?._id;
      return typeof id === 'string' && id.length ? id : null;
    } catch {
      return null;
    }
  }

  private addUserToPayload(body: any, userId: string): any {
    if (!body) {
      return body;
    }

    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        const updated = this.mergeAddedBy(parsed, userId);
        return JSON.stringify(updated);
      } catch {
        return body;
      }
    }

    if (typeof body !== 'object') {
      return body;
    }

    return this.mergeAddedBy(body, userId);
  }

  private mergeAddedBy(payload: any, userId: string): any {
    if (!payload || typeof payload !== 'object') {
      return payload;
    }
    if (payload instanceof FormData) {
      return payload;
    }

    let updatedPayload = payload;
    let changed = false;

    if (!payload.added_by) {
      updatedPayload = { ...updatedPayload, added_by: userId };
      changed = true;
    }

    if (payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
      if (!payload.data.added_by) {
        const updatedData = { ...payload.data, added_by: userId };
        updatedPayload = { ...updatedPayload, data: updatedData };
        changed = true;
      }
    }

    return changed ? updatedPayload : payload;
  }
}
